import { ClearSelectionToolbarItem } from './clear-selection-toolbar-item.js';
import { LayersToolbarItem } from './layers-toolbar-item/layers-toolbar-item.js';
import { MeasureToolbarItem } from './measure-toolbar-item.js';
import { ProbeToolbarItem } from './probe-toolbar-item/probe-toolbar-item.js';
import { SelectionToolbarItem } from './selection-toolbar-item.js';
import { ToggleHoverInfoToolbarItem } from './toggle-hover-info-toolbar-item.js';
import { ToggleOrientationToolbarItem } from './toggle-orientation-toolbar-item.js';
import { TogglePadLabelsToolbarItem } from './toggle-pad-labels-toolbar-item.js';
import { TogglePolygonFillToolbarItem } from './toggle-polygon-fill-toolbar-item.js';

export const ToolbarItems = {
	[ClearSelectionToolbarItem.ItemId]: ClearSelectionToolbarItem,
	[LayersToolbarItem.ItemId]: LayersToolbarItem,
	[MeasureToolbarItem.ItemId]: MeasureToolbarItem,
	[ProbeToolbarItem.ItemId]: ProbeToolbarItem,
	[SelectionToolbarItem.ItemId]: SelectionToolbarItem,
	[ToggleHoverInfoToolbarItem.ItemId]: ToggleHoverInfoToolbarItem,
	[ToggleOrientationToolbarItem.ItemId]: ToggleOrientationToolbarItem,
	[TogglePadLabelsToolbarItem.ItemId]: TogglePadLabelsToolbarItem,
	[TogglePolygonFillToolbarItem.ItemId]: TogglePolygonFillToolbarItem,
};

export const BuiltinToolbarItems = {
	[ClearSelectionToolbarItem.ItemId]: ClearSelectionToolbarItem,
	[ToggleOrientationToolbarItem.ItemId]: ToggleOrientationToolbarItem,
};
